import React, {useState} from "react";

import {Button, Row, Tabs} from "antd";
import styled from "styled-components";
import {PoolPackageBonusCampaigns} from "./components/poolPackageBonusCampaigns/PoolPackageBonusCampaigns";
import {PoolHourlyBonusCampaigns} from "./components/poolHourlyBonusCampaigns/PoolHourlyBonusCampaigns";
import {ArrowLeftOutlined} from "@ant-design/icons";
import {courierBonusCampaignTypes} from "../../../constants/constants";
import {CampaignModal} from "./components/campaignModal/CampaignModal";
import {PoolHourlyGuaranteeCampaigns} from "./components/poolHourlyGuaranteeCampaigns/PoolHourlyGuaranteeCampaigns";

export const TabsContainer = styled(Tabs)`
    @media (max-width: 768px) {
        width: 100%;
        .ant-tabs-nav {
            display: flex;
            flex-direction: column;
        }
        .ant-tabs-nav-list {
            flex-direction: column;
        }
        .ant-tabs-nav-extra {
            width: 100%;
        }
        .ant-tabs-extra-content {
            width: 100% !important;
        }
    }
`;
export const PoolCourierBonusCampaigns = ({poolId}) => {
    const [tabKey, setTabKey] = useState(courierBonusCampaignTypes.PACKAGE_BONUS_FEE.value);
    const [recall, setRecall] = useState(false);
    return (
        <div>
            <Row style={{columnGap: "8px"}}>
                <Button icon={<ArrowLeftOutlined />} onClick={() => history.back()} size="small" />
                <h1>Havuz Bonus Kampanyaları</h1>
            </Row>

            <TabsContainer
                activeKey={tabKey}
                onChange={key => setTabKey(key)}
                tabBarExtraContent={{
                    right: (
                        <CampaignModal
                            poolId={poolId}
                            refetch={() => setRecall(!recall)}
                            campaignType={tabKey}
                            mode="create"
                            buttonLabel="Kurye Bonus Kampanyası Oluştur"
                            modalTitle="Kurye Bonus Kampanyası Oluştur"
                            okButtonLabel="Oluştur"
                        />
                    )
                }}
            >
                <Tabs.TabPane
                    tab={<span>{courierBonusCampaignTypes.PACKAGE_BONUS_FEE.label}</span>}
                    key={courierBonusCampaignTypes.PACKAGE_BONUS_FEE.value}
                >
                    <PoolPackageBonusCampaigns
                        poolId={poolId}
                        isTabOpened={tabKey === courierBonusCampaignTypes.PACKAGE_BONUS_FEE.value}
                        recall={recall}
                        setRecall={() => setRecall(!recall)}
                    />
                </Tabs.TabPane>
                <Tabs.TabPane
                    tab={<span>{courierBonusCampaignTypes.HOURLY_FEE.label}</span>}
                    key={courierBonusCampaignTypes.HOURLY_FEE.value}
                >
                    <PoolHourlyBonusCampaigns
                        poolId={poolId}
                        isTabOpened={tabKey === courierBonusCampaignTypes.HOURLY_FEE.value}
                        recall={recall}
                        setRecall={() => setRecall(!recall)}
                    />
                </Tabs.TabPane>
                <Tabs.TabPane
                    tab={<span>{courierBonusCampaignTypes.HOURLY_GUARANTEE_FEE.label}</span>}
                    key={courierBonusCampaignTypes.HOURLY_GUARANTEE_FEE.value}
                >
                    <PoolHourlyGuaranteeCampaigns
                        poolId={poolId}
                        isTabOpened={
                            tabKey === courierBonusCampaignTypes.HOURLY_GUARANTEE_FEE.value
                        }
                        recall={recall}
                        setRecall={() => setRecall(!recall)}
                    />
                </Tabs.TabPane>
            </TabsContainer>
        </div>
    );
};
